import { makeAutoObservable } from 'mobx'
import { ResHomeInfo, SellHistoryList } from '../constants'
import type { components } from '../constants/schema'
import RootStore from './root'
import { PagingSubStore, SingleSubStore } from './subStore'

export class HomeStore {
  rootStore: RootStore

  mainStore = new SingleSubStore<components['schemas']['HomeItemsDto']>(`/home`) // 캐러셀, 이전 매각 히스토리 등 - 카테고리 클릭시 업데이트 X
  categoryStore = new SingleSubStore<ResHomeInfo>(`/home`) // 판매 예정 작품, 인기 거래 작품 등 - 카테고리 클릭시 업데이트 O
  sellHistoryPagingStore = new PagingSubStore<SellHistoryList>('/home/sellHistories') // 이전 매각 히스토리 상세페이지

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }
}
